import React from 'react';
import AboutBanner from '../../components/AboutUs/AboutBanner/AboutBanner';
import AboutUsContent from '../../components/AboutUs/AboutUsContent/AboutUsContent';
import Team from '../../components/AboutUs/Team/Team';
import Footer from '../../components/Common/Footer/Footer';
import Header from '../../components/Common/Header/Header';
import Review from '../../components/Common/Review/Review';
import SubHeader from '../../components/Common/SubHeader/SubHeader';

const About = () => {
    return (
        <div>
            <SubHeader/>
            <Header/>
            <AboutBanner/>
            <AboutUsContent/>
            <Team/>
            <Review/>
            <Footer/>
        </div>
    );
};

export default About;